import { Component, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  ConfirmByKeypressDirective,
  SkModalBase,
  SkModalContentComponent,
  StrakitButtonPrefixDirective,
} from '@ngx-strakit/cdk';
import { IrisLocalStorageService } from '@iris/common/services/utils/iris-local-storage.service';
import { ClipboardService } from 'ngx-clipboard';
import { IrisEnvironmentService } from '@iris/common/services/environment.service';
import { ToastService } from '@ngx-strakit/cdk/controls/toast';
import { AsyncPipe } from '@angular/common';
import { IrisTimePipe } from '@iris/common/modules/time';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { MatDivider, MatList, MatListItem } from '@angular/material/list';

interface ErrorI {
  date: string;
  method: string;
  requestId: string;
  status: number;
  url: string;
}

@Component({
  selector: 'iris-modal-about',
  styleUrls: ['./iris-modal-about.component.scss'],
  templateUrl: './iris-modal-about.component.html',
  imports: [
    SkModalContentComponent,
    AsyncPipe,
    TranslatePipe,
    IrisTimePipe,
    StrakitButtonComponent,
    MatList,
    MatListItem,
    MatDivider,
    ConfirmByKeypressDirective,
    StrakitButtonPrefixDirective,
  ],
})
export class IrisModalAboutComponent extends SkModalBase<IrisModalAboutComponent, void> {
  private readonly translate = inject(TranslateService);
  private readonly irisLocalStorageService = inject(IrisLocalStorageService);
  private readonly _clipboardService = inject(ClipboardService);
  private readonly toastService = inject(ToastService);
  private readonly envService = inject(IrisEnvironmentService);

  readonly _STORAGE_KEY = 'RequestsErrors';

  status$ = this.envService.getInstanceStatus();
  env = this.envService.env;
  requestErrors = this.irisLocalStorageService.getItem(this._STORAGE_KEY) || [];

  getTitle(): string {
    return this.translate.instant('label.AboutIRIS').toUpperCase();
  }

  clearErrors(): void {
    this.irisLocalStorageService.removeItem(this._STORAGE_KEY);
    this.requestErrors = [];
  }

  onCopy(data: ErrorI | number | string, text: string): void {
    this._clipboardService.copyFromContent(JSON.stringify(data));
    this.onCopySuccess(text);
  }

  onCopySuccess(text: string): void {
    this.toastService.success({ message: this.translate.instant(text) });
  }
}
